import { FinancialStatementPeriodFullWrite, ValuationApproachModel, ValuationApproachPtCompGroup } from 'api';
import { CurrentCompanyMeasurementDate } from 'common/types/measurementDate';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import { FinancialsTransposed } from 'pages/ValuationsAllocation/util';
import afterCellChanged from './config/afterCellChanged';
import getRowConfig from './config/getRowConfig';
import parser from './config/parser';
import reverseParser from './config/reverseParser';
import rowTransformer from './config/rowTransformer';
import validations from './config/validations';
import { GPCAttributes } from '../utils/types';

type CreateGpcDataParams = {
  companyName: string;
  approach: ValuationApproachModel;
  financials: FinancialsTransposed;
  financialsPeriods: FinancialStatementPeriodFullWrite[];
  name: string;
  compGroups: ValuationApproachPtCompGroup[];
  gpcAttributes: GPCAttributes;
  isDisabled: boolean;
  measurementDate: CurrentCompanyMeasurementDate;
  marketDate: string;
};

const createGpcData = ({
  companyName,
  approach,
  financials,
  financialsPeriods,
  name,
  compGroups,
  gpcAttributes,
  isDisabled,
  measurementDate,
  marketDate,
}: CreateGpcDataParams) => {
  const filteredFinancialPeriods = financialsPeriods.filter(
    ({ financial_statement }) => financial_statement === approach.financial_statement
  );
  const rowConfig = getRowConfig({
    companyName,
    approach: approach.valuations_approach_gpc!,
    allCompGroups: compGroups,
    isDisabled,
  });

  const getColumns = () =>
    rowTransformer({
      approach: approach.valuations_approach_gpc!,
      financials,
      financialsPeriods: filteredFinancialPeriods,
      financialStatementId: approach.financial_statement!,
      measurementDate,
      marketDate,
    });

  const columns = getColumns();

  return new SpreadsheetConfig({
    columns,
    rowConfig,
    parser,
    name,
    tableData: {
      companyName,
      approach,
      financials,
      financialsPeriods: filteredFinancialPeriods,
      isDisabled,
      marketDate,
    },
    showToolbar: true,
    reverseParser: reverseParser as unknown as SpreadsheetConfig['reverseParser'],
    customValidations: validations as any,
    afterCellChanged: afterCellChanged as unknown as SpreadsheetConfig['afterCellChanged'],
    currencyFormatter: true,
    unitsFormatter: true,
    allowConfirmAndDeleteColumn: false,
    fieldAttributes: gpcAttributes,
    allowCopyColumn: false,
    allowReorderColumns: false,
    allowCopyRows: !isDisabled,
    allowAddSingleRow: !isDisabled,
    allowDeleteRow: !isDisabled,
    reverseParseAfterLoad: approach.valuations_approach_gpc?.is_evaluating_equity_value,
    getColumns,
    format: undefined,
    totalParser: undefined,
  });
};

export default createGpcData;
